import FiltersManager2 from "../../../manager/filters/filters-manager-2";
import GenericListModule from "../generic-list-module";
import FieldProto from "../../../fields3/proto/field-proto";

export default class GList_FiltersManager extends FiltersManager2 {

    public module       : GenericListModule

    constructor(module:GenericListModule, currentFilters:any, onChangeCallback:onChangeCallback) {
        const fields : FieldProto[] = module.fields.all();

        super(module, fields, currentFilters, onChangeCallback);

        this.module = module
    }

    onChange(updatedFilter:any) {
        super.onChange(updatedFilter);

        /*// every time filters change save value to local settings
        this.app.settings.filters = this.toObject();

        // show loading only for bigger projects
        this.app.dataContainer.length>70 && gd.bus.triggerEvent("app-show-loading-overlap");*/

        //set timeout for app-show-loading-overlap to have time for render
        setTimeout(()=>{
            this.module.data.process();
            this.module.reRender();
        },0);
    }

    // apply filter and ghost when needed
    filterItems(items:any) {
        return super.filterItems(items);
    }

    // required while @ts-ignore for FiltersManager2 is present
    resetAll() {
        super.resetAll()
    }
}